

<ion-app [class.ion-palette-dark]="dark">

<!--<ion-split-pane contentId="main-content" [when]="showSplitPane" *ngIf="showMenu"  >-->
   <ion-split-pane contentId="main-content" *ngIf="showMenu" >  
    <ion-menu contentId="main-content">
      <ion-content>
        <ion-list lines="none">
          <ion-list-header>Inbemetal</ion-list-header>
          <!-- Menu items -->
          <ion-menu-toggle autoHide="false" *ngFor="let p of appPages">
            <ion-item [routerLink]="[p.url]"
                      [queryParams]="p.queryParams"
                      routerDirection="root"
                      detail="false">
              <ion-icon slot="start" [name]="p.icon + '-outline'"></ion-icon>
              <ion-label>{{ p.title }}</ion-label>
            </ion-item>
          </ion-menu-toggle>
          <!-- <ion-menu-toggle autoHide="false" *ngFor="let p of appPages; let i = index">
            <ion-item [routerLink]="p.url" routerLinkActive="selected" routerDirection="root" detail="false">
              <ion-icon slot="start" [name]="p.icon + '-outline'"></ion-icon>
              <ion-label>{{p.title}}</ion-label>
            </ion-item>
          </ion-menu-toggle> -->
        </ion-list>
        <!-- Rest of the menu -->

        <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/login" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="log-in"></ion-icon>
              <ion-label>Módulo Autenticación</ion-label>
            </ion-item>
          </ion-menu-toggle>


        <ion-list *ngIf="loggedIn" lines="none">
          <ion-list-header>Account</ion-list-header>
          <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/account" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="person"></ion-icon>
              <ion-label>Account</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/support" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="help"></ion-icon>
              <ion-label>Support</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false">
            <ion-item button (click)="logout()" detail="false">
              <ion-icon slot="start" name="log-out"></ion-icon>
              <ion-label>Salir</ion-label>
            </ion-item>
          </ion-menu-toggle>

        </ion-list>

        <ion-list *ngIf="!loggedIn" lines="none">
          <ion-list-header>Ajustes</ion-list-header>

          <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/app/tabs/order" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="person-circle"></ion-icon>
              <ion-label>Mi cuenta</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <!-- <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/support" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="document-text-outline"></ion-icon>
              <ion-label>AVISO LEGAL</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/support" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="receipt-outline"></ion-icon>
              <ion-label>Terminos y condiciones</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-menu-toggle autoHide="false">
            <ion-item routerLink="/account" routerLinkActive="active" routerDirection="root" detail="false">
              <ion-icon slot="start" name="person-outline"></ion-icon>
              <ion-label>Mi cuenta</ion-label>
            </ion-item>
          </ion-menu-toggle>

          <ion-item>
            <ion-icon slot="start" name="moon-outline"></ion-icon>
            <ion-toggle [(ngModel)]="dark">Modo Oscuro</ion-toggle>
          </ion-item> -->
        </ion-list>

        <!-- <ion-list lines="none">
          <ion-list-header>
            Tutorial
          </ion-list-header>
          <ion-menu-toggle autoHide="false">
            <ion-item button (click)="openTutorial()" detail="false">
              <ion-icon slot="start" name="hammer"></ion-icon>
              <ion-label>Tutorial</ion-label>
            </ion-item>
          </ion-menu-toggle>
        </ion-list> -->
      </ion-content>
    </ion-menu>
    <ion-router-outlet id="main-content"></ion-router-outlet>
  </ion-split-pane>

   <ion-router-outlet *ngIf="!showMenu" id="main-content"></ion-router-outlet> 
</ion-app>



<!--<ion-app [class.ion-palette-dark]="dark">-->
  <!--<ion-split-pane contentId="main-content" *ngIf="showMenu"   >-->
    <!--<ion-menu contentId="main-content">-->
      <!--<ion-content>-->
        <!--<ion-list lines="none">-->
          <!--<ion-list-header>Inbemetal</ion-list-header>-->
          <!--[> Menu items <]-->
          <!--<ion-menu-toggle autoHide="false" *ngFor="let p of appPages">-->
            <!--<ion-item [routerLink]="[p.url]"-->
                      <!--[queryParams]="p.queryParams"-->
                      <!--routerDirection="root"-->
                      <!--detail="false">-->
              <!--<ion-icon slot="start" [name]="p.icon + '-outline'"></ion-icon>-->
              <!--<ion-label>{{ p.title }}</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->
          <!--<!-- <ion-menu-toggle autoHide="false" *ngFor="let p of appPages; let i = index">-->
            <!--<ion-item [routerLink]="p.url" routerLinkActive="selected" routerDirection="root" detail="false">-->
              <!--<ion-icon slot="start" [name]="p.icon + '-outline'"></ion-icon>-->
              <!--<ion-label>{{p.title}}</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle> -->-->
        <!--</ion-list>-->
        <!--[> Rest of the menu <]-->

        <!--<ion-menu-toggle autoHide="false">-->
            <!--<ion-item routerLink="/login" routerLinkActive="active" routerDirection="root" detail="false">-->
              <!--<ion-icon slot="start" name="log-in"></ion-icon>-->
              <!--<ion-label>Módulo Autenticación</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->


        <!--<ion-list *ngIf="loggedIn" lines="none">-->
          <!--<ion-list-header>Account</ion-list-header>-->
          <!--<ion-menu-toggle autoHide="false">-->
            <!--<ion-item routerLink="/account" routerLinkActive="active" routerDirection="root" detail="false">-->
              <!--<ion-icon slot="start" name="person"></ion-icon>-->
              <!--<ion-label>Account</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->

          <!--<ion-menu-toggle autoHide="false">-->
            <!--<ion-item routerLink="/support" routerLinkActive="active" routerDirection="root" detail="false">-->
              <!--<ion-icon slot="start" name="help"></ion-icon>-->
              <!--<ion-label>Support</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->

          <!--<ion-menu-toggle autoHide="false">-->
            <!--<ion-item button (click)="logout()" detail="false">-->
              <!--<ion-icon slot="start" name="log-out"></ion-icon>-->
              <!--<ion-label>Salir</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->

        <!--</ion-list>-->

        <!--<ion-list *ngIf="!loggedIn" lines="none">-->
          <!--<ion-list-header>Ajustes</ion-list-header>-->

          <!--<ion-menu-toggle autoHide="false">-->
            <!--<ion-item routerLink="/app/tabs/order" routerLinkActive="active" routerDirection="root" detail="false">-->
              <!--<ion-icon slot="start" name="log-in"></ion-icon>-->
              <!--<ion-label>Mi cuenta</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->

          <!--<!-- <ion-menu-toggle autoHide="false">-->
            <!--<ion-item routerLink="/support" routerLinkActive="active" routerDirection="root" detail="false">-->
              <!--<ion-icon slot="start" name="document-text-outline"></ion-icon>-->
              <!--<ion-label>AVISO LEGAL</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->

          <!--<ion-menu-toggle autoHide="false">-->
            <!--<ion-item routerLink="/support" routerLinkActive="active" routerDirection="root" detail="false">-->
              <!--<ion-icon slot="start" name="receipt-outline"></ion-icon>-->
              <!--<ion-label>Terminos y condiciones</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->

          <!--<ion-menu-toggle autoHide="false">-->
            <!--<ion-item routerLink="/account" routerLinkActive="active" routerDirection="root" detail="false">-->
              <!--<ion-icon slot="start" name="person-outline"></ion-icon>-->
              <!--<ion-label>Mi cuenta</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->

          <!--<ion-item>-->
            <!--<ion-icon slot="start" name="moon-outline"></ion-icon>-->
            <!--<ion-toggle [(ngModel)]="dark">Modo Oscuro</ion-toggle>-->
          <!--</ion-item> -->-->
        <!--</ion-list>-->

        <!--<!-- <ion-list lines="none">-->
          <!--<ion-list-header>-->
            <!--Tutorial-->
          <!--</ion-list-header>-->
          <!--<ion-menu-toggle autoHide="false">-->
            <!--<ion-item button (click)="openTutorial()" detail="false">-->
              <!--<ion-icon slot="start" name="hammer"></ion-icon>-->
              <!--<ion-label>Tutorial</ion-label>-->
            <!--</ion-item>-->
          <!--</ion-menu-toggle>-->
        <!--</ion-list> -->-->
      <!--</ion-content>-->
    <!--</ion-menu>-->
    <!--<ion-router-outlet id="main-content"></ion-router-outlet>-->
  <!--</ion-split-pane>-->

   <!--<ion-router-outlet *ngIf="!showMenu" id="main-content"></ion-router-outlet> -->
<!--</ion-app>-->


